export class UserType {
  id?: number;
  name?: string;
  active?: boolean;
  regexComment?: string;
  regexPassword?: string;
  languageId?: number;
  permanentSession?: boolean;
  concurrentSessions?: boolean;
  inactivityTime?: number;
  sessionTime?: number;

  constructor(source: Partial<UserType>) {
    Object.assign(this, source);
  }
}
